<template>
  <div class="list-warp">
    <div class="left-btn" v-if="activeIndex > 0 && pageList.length > 1" @click="clickPrev">
      <i class="el-icon-arrow-left"></i>
    </div>
    <div class="right-btn" v-if="activeIndex < (pageList.length - 1) && pageList.length > 1" @click="clickNext">
      <i class="el-icon-arrow-right"></i>
    </div>
    <el-carousel class="supplier-slide"
                 ref="quotationSlide"
                 height="310px"
                 :autoplay="false"
                 arrow1="always"
                 arrow="never"
                 trigger="click"
                 indicator-position="none"
                 @change="(val) => activeIndex = val"
    >
      <el-carousel-item class="supplier-slide__item"
        v-for="(pageItemData,index) in pageList"
        :key="index">
        <quotation-item v-for="quotation in pageItemData" :key="quotation.id" style="margin-bottom: 10px" :quotation="quotation" @checkItem="checkItem(quotation)"></quotation-item>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
// import PriceBlurring from "../../../../../common/priceBlurring";
import quotationItem from './quotationItem.vue'

export default {
  components: { quotationItem },
  props:{
    list:{
      type:Array,
      default:()=>[]
    }
  },
  data(){
    return {
      activeIndex: 0
    }
  },
  computed: {
    pageList() {
      return this.groupList(this.list)
    }
  },
  methods:{
    checkItem(item) {
      this.$emit('checkItem', item)
    },
    /**
     * 轮播视图分组
     * @param originList
     * @returns {*[]}
     */
    groupList(originList = []){
      let list = [];
      let itemArr = [];
      originList.forEach((item,index)=>{
        itemArr.push(item);
        if((index+1)%4){
          if((index+1) === originList.length) list.push(itemArr);
        }else{
          list.push(itemArr);
          itemArr = [];
        }
      })
      return list;
    },
    clickPrev(){
      this.$refs.quotationSlide.prev();
    },
    clickNext(){
      this.$refs.quotationSlide.next();
    },
    noEvent(){},
  }
}
</script>
<style lang="scss" scoped>
  .list-warp {
    position: relative;
  }
  .left-btn, .right-btn {
    position: absolute;
    width: 30px;
    height: 30px;
    line-height: 32px;
    text-align: center;
    font-size: 16px;
    background: rgba(0,0,0,0.2);
    color: #FFFFFF;
    border: 1px solid #FFFFFF;
    border-radius: 30px;
    cursor: pointer;
    // &.disabled {
    //   opacity: .5;
    //   cursor: no-drop;
    // }
  }
  .left-btn {
    top: calc(50% - 30px);
    left: -50px;
  }
  .right-btn {
    top: calc(50% - 30px);
    right: -50px;
  }
</style>


// WEBPACK FOOTER //
// src/components/placeOrder/components/globalCloudWareQuotation/quotationCarousel.vue